export { default as ProductViewShare } from './ProductViewShare';
